export default {
  text: 'Sales',
  thumbnail:
    'https://vastreach.com/static_assets/email/thumnails/Sales_email_1.jpg',
  snippets: {
    Button: {
      icon: 'RadioButton',
      text: 'Button',
      editor: 'button',
      html: '<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;"><p style="text-align: center;margin:0;"><a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#ffffff" data-button-background-color="#18c825" href="#" target="_blank"><button style="color: #ffffff; background-color: #18c825;border: 0; padding: 15px 25px; margin: 0; border-radius: 0.3rem; cursor: pointer;"><strong>Start Now</strong></button></a></p></div><!-- End of Dynamic WYSIWYG Content -->',
    },
    Social: {
      icon: 'Share',
      text: 'Social',
      editor: 'social-media',
      html: '<!-- Dynamic WYSIWYG Content --><table style="margin: 0 auto;background: transparent;" border="0" cellpadding="0" cellspacing="0" align="center"><tr><td width="600" align="center"><table style="margin: 20px 0 20px 0;"><tr><td align="center"> <a data-social-media="facebook" href="https://www.facebook.com/" target="_blank"><img src="https://vastreach.com/static_assets/facebook.png" border="0" style="background-color: #18c825; padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="instagram" href="https://www.instagram.com/" target="_blank"><img src="https://vastreach.com/static_assets/instagram.png" border="0" style="background-color: #18c825;padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="twitter" href="https://twitter.com/" target="_blank"><img src="https://vastreach.com/static_assets/twitter.png" border="0" style="background-color: #18c825;padding: 4px; border-radius:28px;" /></a> </td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
    Paragraph: {
      icon: 'Notes',
      text: 'Paragraph',
      editor: 'wysiwyg',
      html: `<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;"> <p><strong><span style="font-size: medium;color:#777777;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">We have over 40 Hot Tubs & Swim Spas on Display from Major Brands and Everything Must Go! </span></strong></p></div><!-- End of Dynamic WYSIWYG Content -->`,
    },
    Header: {
      icon: 'Title',
      text: 'Header',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px; margin: 0 auto; padding: 10px; text-align: center; background: transparent; line-height: 1.65; font-size: 100%;"><h1 style="color: #18c825; padding: 0; text-align: center; font-weight: bold;"><span style="font-size: x-large; font-family: Arial, Helvetica, sans-serif;">Header</span></h1></div><!-- End of Dynamic WYSIWYG Content -->',
    },
    'Image + Paragraph': {
      icon: 'Image',
      text: 'Image + Paragraph',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><table style="width: 100%;max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;"><tr><td><table border="0" cellpadding="0" cellspacing="0" width="100%" style="padding: 20px;border-spacing: 0;"><tr><td valign="top" width="33.33%"><table border="0" cellpadding="0" cellspacing="0" style="border-spacing: 0;"><tr><td dir="ltr" valign="top" style="padding: 0 15px 15px 0"><img src="https://vastreach.com/static_assets/email/sales_email_1/featured-2.jpg" alt="featured item 2" style="max-width: 100%;margin: 0 auto;display: block;"></td></tr></table></td><td valign="top" width="66.66%"><table border="0" cellpadding="0" cellspacing="0" style="border-spacing: 0;"><tr><td dir="ltr" valign="top" style="text-align: left;"><h2><span style="font-size: x-large;font-family: Arial, Helvetica, sans-serif;">Featured item 2</span></h2><p><strong><span style="font-size: medium;color:#777777;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Describe your featured item here. Explain it just enough for the viewer to get an idea of what it is, but not the whole picture so they may get curious and visit your link.</span></strong></p></td></tr></table></td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
    'Image Banner + Text': {
      icon: 'Satellite',
      text: 'Image Banner + Text',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><table style="width: 100%;max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;background: transparent;"><tr><td><table border="0" cellpadding="0" cellspacing="0" valign="middle" style="background-image: url(https://vastreach.com/static_assets/email/sales_email_1/lower_banner.jpg);background-position: center center !important;background-size: cover !important;text-align: center;border-spacing: 0;"><tr><td valign="middle" style="text-align: center; padding: 50px 50px 50px 50px; font-size: 15px; color: #18c825;"><h2 style="font-size: 30px;">SALE ENDS FRIDAY AT MIDNIGHT! DON NOT MISS OUT!<br /></h2> </td></tr> </table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
  },
  value: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" style="width: 100%;height: 100%;margin: 0;padding: 0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">

<head>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
  <meta name="viewport" content="width=device-width"/>
  <meta class="vastreach-theme" data-vast-theme="sales"/>
</head>	

<body align="center" style="margin: 0;padding:0;background-color: #ffffff;">
  <div class="background" style="background: #ffffff;">
    <div class="foreground" style="max-width: 600px;background: #ffffff;">
		<table style="max-width: 600px;margin: 0 auto;padding: 0;text-align: center;border-spacing: 0;">	
			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;background: transparent;">
						<tr>
							<td>				
								<table style="border-spacing: 0;">
									<tr>
										<td style="background-image: url(https://vastreach.com/static_assets/email/sales_email_1/banner.jpg);background-position: center center !important;background-size: cover !important;text-align: center;padding: 0 10px 0 10px;">
											<table border="0" cellpadding="0" cellspacing="0" width="100%" valign="middle" style="border-spacing: 0;">
												<tr>
													<td class="col" width="290" valign="middle" align="left">
														<table cellpadding="0" cellspacing="0" style="border-spacing: 0;">
															<tr>
																<td>
																<img src="https://vastreach.com/static_assets/email/sales_email_1/beta-logo.png" alt="logo" style="max-width: 300px;margin: 0 auto;display: block;" />
																</td>
															</tr>
														</table>
													</td>
													<td class="col" width="290" valign="middle" align="right">
														<table cellpadding="0" cellspacing="0" style="border-spacing: 0;">
															<tr>
																<td>
																<h2 style="margin-right: 10px; color: #ffffff;"><span style="font-size: medium;font-family: Arial, Helvetica, sans-serif;">Free Shipping over $50.</span></h2>
																</td>
															</tr>
														</table>
													</td>
												</tr>
											</table>
											<table border="0" cellpadding="0" cellspacing="0" style="border-spacing: 0;">
												<tr>
													<td valign="middle" style="text-align: center; padding: 50px; font-size: 15px;color: #ffffff;">
														<h2><span style="font-size: xx-large;font-family: Arial, Helvetica, sans-serif;">GET EARLY ACESS TO OUR SALE!<br /> <b style="font-size: 50px; color: #18c825;">25-50% OFF!</b></strong></h2>
														<!--<p><a href="#" target="_blank"><button style=" color: #ffffff;background-color: #18c825;border: 0;padding: 15px 25px; cursor: pointer;"><b>VISIT STORE</b></button></a></p>-->                          
													</td>
												</tr>	                                   	
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>							
					<!-- End of Dynamic WYSIWYG Content -->	
				<td/>
			</tr>

			<tr>
			<td dir="ltr" valign="top" width="100%" class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
				<!-- Dynamic WYSIWYG Content -->
				<div style="max-width: 600px;margin: 0 auto;padding: 20px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
					<img src="https://vastreach.com/static_assets/email/sales_email_1/header.jpg" alt="header image" style="width: 100%;margin: 0 auto;display: block;" />
				</div>						
				<!-- End of Dynamic WYSIWYG Content -->
			</td>
			</tr>

			<tr>
			<td dir="ltr" valign="top" width="100%" class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
				<!-- Dynamic WYSIWYG Content -->
				<div style="max-width: 600px;margin: 0 auto;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
					<h2><span style="font-size: x-large;font-family: Arial, Helvetica, sans-serif;">Your heading goes here</span></h2>
				</div>						
				<!-- End of Dynamic WYSIWYG Content -->
			</td>
			</tr>
			
			<tr>
			<td dir="ltr" valign="top" width="100%" class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
				<!-- Dynamic WYSIWYG Content -->
				<div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;">        
					<p><strong><span style="font-size: medium;color:#777777;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Describe how you can you your reader can save money by taking advantage of this sale. Make sure to leave the key features to highlight below in more detail.</span></strong></p>
				</div>					
				<!-- End of Dynamic WYSIWYG Content -->
			</td>
			</tr>			

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">				
						<h2 style="color: #18c825; text-align: center;"><span style="font-size: x-large;font-family: Arial, Helvetica, sans-serif;">FEATURED ITEMS</span></h2>
					</div>							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr> 

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px 20px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">			
						<hr>
					</div>							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr> 		

			<tr>
				<td dir="ltr" valign="top" width="100%" class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<tr>
							<td>					
								<table border="0" cellpadding="0" cellspacing="0" width="100%" style="padding: 20px;border-spacing: 0;">
									<tr>
										<td valign="top" width="33.33%">
											<table border="0" cellpadding="0" cellspacing="0" style="border-spacing: 0;">
												<tr>
													<td dir="ltr" valign="top" style="padding: 0 15px 15px 0">
														<img src="https://vastreach.com/static_assets/email/sales_email_1/featured-1.jpg" alt="featured item 1" style="max-width: 100%;margin: 0 auto;display: block;">
													</td>
												</tr>
											</table>
										</td>
										<td valign="top" width="66.66%">
											<table border="0" cellpadding="0" cellspacing="0" style="border-spacing: 0;">
												<tr>
													<td dir="ltr" valign="top" style="text-align: left;">
														<h2><span style="font-size: x-large;font-family: Arial, Helvetica, sans-serif;">Featured item 1</span></h2>
														<p><strong><span style="font-size: medium;color:#777777;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Describe your featured item here. Explain it just enough for the viewer to get an idea of what it is, but not the whole picture so they may get curious and visit your link.</span></strong></p>
														<!--<table cellspacing="0" cellpadding="0" border="0" style="float:left;border-spacing: 0;">
															<tr>
																<td>
																	<p style="color: #18c825;"><a href="#" target="_blank">See in Store</a></p>
																</td>
															</tr>
														</table>-->
													</td>
												</tr>
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>

			<tr>
				<td dir="ltr" valign="top" width="100%" class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<tr>
							<td>					
								<table border="0" cellpadding="0" cellspacing="0" width="100%" style="padding: 20px;border-spacing: 0;">
									<tr>
										<td valign="top" width="33.33%">
											<table border="0" cellpadding="0" cellspacing="0" style="border-spacing: 0;">
												<tr>
													<td dir="ltr" valign="top" style="padding: 0 15px 15px 0">
														<img src="https://vastreach.com/static_assets/email/sales_email_1/featured-2.jpg" alt="featured item 2" style="max-width: 100%;margin: 0 auto;display: block;">
													</td>
												</tr>
											</table>
										</td>
										<td valign="top" width="66.66%">
											<table border="0" cellpadding="0" cellspacing="0" style="border-spacing: 0;">
												<tr>
													<td dir="ltr" valign="top" style="text-align: left;">
														<h2><span style="font-size: x-large;font-family: Arial, Helvetica, sans-serif;">Featured item 2</span></h2>
														<p><strong><span style="font-size: medium;color:#777777;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Describe your featured item here. Explain it just enough for the viewer to get an idea of what it is, but not the whole picture so they may get curious and visit your link.</span></strong></p>
														<!--<table cellspacing="0" cellpadding="0" border="0" style="float:left;border-spacing: 0;">
															<tr>
																<td>
																	<p style="color: #18c825;"><a href="#" target="_blank">See in Store</a></p>
																</td>
															</tr>
														</table>-->
													</td>
												</tr>
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<tr>
							<td>				
								<table border="0" cellpadding="0" cellspacing="0" valign="middle" style="background-image: url(https://vastreach.com/static_assets/email/sales_email_1/lower_banner.jpg);background-position: center center !important;background-size: cover !important;text-align: center;border-spacing: 0;">
									<tr>
										<td valign="middle" style="text-align: center; padding: 50px 50px 50px 50px; font-size: 15px; color: #18c825;">
											<h2><span style="font-size: xx-large;font-family: Arial, Helvetica, sans-serif;">SALE ENDS FRIDAY AT MIDNIGHT! DON'T MISS OUT!</span><br /></h2>                           
										</td>
									</tr>	                                   	
								</table>
							</td>
						</tr>
					</table>							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>                         									
		</table> 	
	</div>				
</div>				
</body>	
</html>`,
}
